import { EditOutlined } from '@ant-design/icons'
import { AUTHORITIES } from '@app/constants/authorities'
import { host_without_last_slash } from '@app/constants/env'
import useLocalization from '@app/hooks/useLocalization'
import { IEmployee } from '@app/interfaces/employee/employee'
import { IFile } from '@app/interfaces/files'
import AddEmployeeAvatarForm from '@app/pages/organizations/components/organization-employee/components/employee-organization/components/employee-info/components/add-employee-avatar-form'
import RemoveEmployeeAvatarForm from '@app/pages/organizations/components/organization-employee/components/employee-organization/components/employee-info/components/remove-employee-avatar-form'
import { capitalizeName } from '@app/utils/capitalize/capitalize'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { Card, Descriptions, Image, Spin } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

interface props {
  _employee?: IEmployee
  avatar: IFile
  preload: IFile
  imageUpdated: boolean
  setImageUpdated: (data: boolean) => void
}

interface params {
  id?: string
  employeeId?: string
}

const EmployeeInfo: React.FC<props> = ({
  _employee,
  avatar,
  setImageUpdated,
  imageUpdated,
}) => {
  const [t] = useTranslation()
  const params: params = useParams()
  const [imageUploading, setImageUploading] = useState<boolean>(false)
  const { localizeData } = useLocalization()

  const permissions = [AUTHORITIES.SUSER]
  const organizationId = Number(params.id)

  const newMenu = (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
      }}>
      <AddEmployeeAvatarForm
        employee={_employee}
        edit={_employee?.fileId ? true : false}
        organizationId={organizationId}
      />
      {_employee?.fileId && (
        <RemoveEmployeeAvatarForm
          employee={_employee}
          organizationId={organizationId}
        />
      )}
    </div>
  )

  return (
    <>
      <Card
        extra={
          rolesChecker(permissions) ? (
            <Link
              to={`/organization/${params.id}/employees/employee/${params.employeeId}/edit`}
              type={'primary'}>
              <EditOutlined />
              {t('general.edit')}
            </Link>
          ) : null
        }
        title={`${_employee?.lastName ?? ''} ${_employee?.firstName ?? ''} ${
          _employee?.middleName ?? ''
        }`}>
        <Spin spinning={imageUploading}>
          <div className="avatar">
            <p>{t('users.avatar')}</p>
            {avatar.id && _employee?.fileId ? (
              <Image
                width={200}
                src={`${host_without_last_slash}/files${avatar?.baseURL}/750x750-${avatar?.filePath}`}
              />
            ) : (
              <Image
                style={{ cursor: 'pointer' }}
                width={150}
                height={150}
                src="error"
                fallback="data:image/png;base64,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"
              />
            )}
            {newMenu}
          </div>
          <Descriptions size={'middle'} column={1} bordered>
            <Descriptions.Item label={'ID'}>{_employee?.id}</Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.fullName')}>
              {capitalizeName(
                `${_employee?.lastName ?? ''} ${_employee?.firstName ?? ''} ${
                  _employee?.middleName ?? ''
                }`,
              )}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.email')}>
              {_employee?.email}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.phone')}>
              {_employee?.phone}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.address')}>
              {_employee?.address}
            </Descriptions.Item>
            {rolesChecker([AUTHORITIES.ADMIN]) ? (
              <Descriptions.Item label={t('users.manageUser')}>
                {' '}
                <Link
                  to={`/manage-users/users/user/${_employee?.securityUserId}`}>
                  {_employee?.securityUserId}
                </Link>
              </Descriptions.Item>
            ) : null}
            <Descriptions.Item label={t('employeeFields.tin')}>
              {_employee?.tin}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.pin')}>
              {_employee?.pin}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.passportNumber')}>
              {_employee?.passportNumber}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.gender')}>
              {_employee?.gender === 'MALE'
                ? t('general.male')
                : t('general.female')}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.education')}>
              {
                localizeData(_employee?.education?.educationDictionary?.data)
                  ?.name
              }
            </Descriptions.Item>
            <Descriptions.Item label={t('educationDegree.educationDegree')}>
              {localizeData(_employee?.degreeEducation?.data)?.name}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.placeStudy')}>
              {_employee?.education?.placeStudy}
            </Descriptions.Item>
            <Descriptions.Item label={t('employeeFields.specialty')}>
              {_employee?.education?.specialty}
            </Descriptions.Item>
          </Descriptions>
        </Spin>
      </Card>
    </>
  )
}

function mapStateToProps(state) {
  return {
    _employee: state.organizationEmployee.employee,
  }
}

export default connect(mapStateToProps)(EmployeeInfo)
